// ============================================================
//  src/admin/pages/AdminPocketfiPage.js
// ============================================================
import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import { getPocketfiConfig, savePocketfiConfig } from '../api/adminClient';
import { PageHeader } from '../components/UI';

const EMPTY = { business_id: '', api_key: '', api_secret: '', base_url: 'https://pocketfi.ng', redirect_url: '' };

export default function AdminPocketfiPage() {
  const [form, setForm] = useState(EMPTY);
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getPocketfiConfig().then(res => {
      const c = res.data.config;
      setForm({
        business_id: c.business_id || '',
        api_key: c.api_key || '',       // masked, e.g. "••••ab12"
        api_secret: c.api_secret || '', // masked
        base_url: c.base_url || 'https://pocketfi.ng',
        redirect_url: c.redirect_url || '',
      });
      setConfigured(c.configured);
    }).finally(() => setLoading(false));
  }, []);

  async function handleSave(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await savePocketfiConfig(form);
      toast.success('PocketFi settings saved');
    } catch (e2) {
      toast.error(e2?.response?.data?.message || 'Save failed');
    } finally {
      setSaving(false);
    }
  }

  if (loading) return <div className="bf-empty"><span className="spinner spinner-dark" /> Loading…</div>;

  return (
    <div className="bf-page" style={{ maxWidth: 640 }}>
      <PageHeader
        title="PocketFi Configuration"
        subtitle="Credentials used to process payments via PocketFi's checkout API. Stored securely in the database — never hardcoded."
      />

      <div className="bf-card" style={{ borderColor: configured ? 'var(--bf-success)' : 'var(--bf-warning)' }}>
        <div className="bf-card-body" style={{ fontSize: 13, color: configured ? 'var(--bf-success)' : 'var(--bf-warning)', fontWeight: 600 }}>
          {configured ? '✅ PocketFi is configured — checkout is enabled.' : '⚠️ PocketFi is not fully configured — plan upgrades requiring payment are disabled until business_id and api_key are set.'}
        </div>
      </div>

      <form onSubmit={handleSave} className="bf-card">
        <div className="bf-card-hdr">Credentials</div>
        <div className="bf-card-body" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <div className="bf-field">
            <label className="bf-field-label">Business ID</label>
            <input className="bf-input" value={form.business_id} onChange={e => setForm({ ...form, business_id: e.target.value })} placeholder="e.g. 29492" />
          </div>
          <div className="bf-field">
            <label className="bf-field-label">API Key</label>
            <input className="bf-input" value={form.api_key} onChange={e => setForm({ ...form, api_key: e.target.value })} placeholder="sk_live_..." />
            <div className="bf-field-hint">Leave unchanged (showing as •••• ) to keep the current value</div>
          </div>
          <div className="bf-field">
            <label className="bf-field-label">API Secret</label>
            <input className="bf-input" value={form.api_secret} onChange={e => setForm({ ...form, api_secret: e.target.value })} placeholder="••••" />
            <div className="bf-field-hint">Leave unchanged (showing as •••• ) to keep the current value</div>
          </div>
          <div className="bf-field">
            <label className="bf-field-label">Base URL</label>
            <input className="bf-input" value={form.base_url} onChange={e => setForm({ ...form, base_url: e.target.value })} />
          </div>
          <div className="bf-field">
            <label className="bf-field-label">Redirect URL</label>
            <input className="bf-input" value={form.redirect_url} onChange={e => setForm({ ...form, redirect_url: e.target.value })} placeholder="https://yourapp.com/billing" />
            <div className="bf-field-hint">Where customers return to after completing payment, e.g. https://yourapp.com/billing</div>
          </div>
          <button className="btn btn-primary" type="submit" disabled={saving} style={{ alignSelf: 'flex-start' }}>
            {saving ? 'Saving…' : 'Save Settings'}
          </button>
        </div>
      </form>
    </div>
  );
}